import {Component, ComponentRef, EnvironmentInjector, inject, ViewChild, ViewContainerRef} from '@angular/core';
import {IonicModule, ModalController} from "@ionic/angular";
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-select-dialog',
  templateUrl: './select-dialog.component.html',
  styleUrls: ['./select-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,     // directives Angular de base + provider pour DOCUMENT
    IonicModule,      // composants Ionic
    MatIconModule
  ]
})
export class SelectDialogComponent  {
  @ViewChild('componentHost', { read: ViewContainerRef }) componentHost!: ViewContainerRef;

  dialogTitleHeight: any;
  documentHeight: any;

  matIcon: any;
  modalTitle: string = '';
  component: any;
  model: any;
  filters: any = [];
  fixedFilters: any = [];

  private envInjector = inject(EnvironmentInjector);
  private document = inject(DOCUMENT);
  
  constructor(
    private modalCtrl: ModalController    
  ) { }

  ionViewDidEnter() {
    this.loadDynamicComponent();
  }

  loadDynamicComponent() {
    if(this.component) {

      let componentRef: ComponentRef<any>;
      try {
        componentRef = this.componentHost.createComponent(this.component, { injector: this.envInjector });
        // log de toutes les props
        componentRef.instance.model = this.model;
        componentRef.instance.filters = this.filters;
        componentRef.instance.fixedFilters = this.fixedFilters;
        componentRef.instance.resSelectEvent.subscribe((data: any) => {
          // Faire quelque chose lorsque l'événement est émis
          if(data) {
            this.modalCtrl.dismiss(data, 'confirm');
          }
        });
        componentRef.changeDetectorRef.detectChanges();
        
      } catch(e: any) {
        console.error('Error creating component:', e);
      }
    }

    this.initDocumentHeight()
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  private initDocumentHeight() {
    this.documentHeight = this.document?.defaultView?.outerHeight;
    this.dialogTitleHeight = this.document?.getElementById('dialog-title')?.offsetHeight;
  }
}
